/* eslint-disable  */
import React, { useEffect, useState, useMemo } from 'react';
import { connect } from 'react-redux';
import dayjs from 'dayjs';
import {
    Table, Input, Icon
} from 'semantic-ui-react';
import { actions as renewalActions } from './sagaSlice';
import usePrint from '+/hooks/usePrint';
import { useProperty } from '~/properties';
import logo from '../../logo.png';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import orderBy from 'lodash/orderBy';
import { Typography, Grid } from '@material-ui/core';
import {
    Card, CardContent
} from '@material-ui/core';
import { capitalize } from 'voca';
import { PrintDate } from '../../shared/components/PrintDate';


const styles = {
    headerContainer: {
        padding: 15
    },
    containerReport: {
        padding: '10px'
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between'
    },
    logoWrapper: {
        position: 'absolute',
        left: '55%',
        transform: 'translateX(-50%)'
    },
    logo: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: 200
    },
    timeStamp: {
        display: 'flex',
        alignItems: 'flex-end',
        padding: '0 60px'
    }
};

const dateAtMidnight = date => dayjs(date)
    .hour(0)
    .minute(0)
    .second(0)
    .millisecond(0)
    .toDate();


const formattedDate = date => dayjs(date).format('MM-YYYY');

const categorizeIncrease = (bestRate, currentRent, goingRent, whip_status) => {

    const colors = [];
    //blue
    colors.push('#002144');
    //yellow
    colors.push('#c38f00');
    //green
    colors.push('#00af5b');
    //blue
    colors.push('#B7D5F4');
    //lightGreen
    colors.push('#88e27cbf');
    //lightBlue
    colors.push('#a5eff1bf');
    //orange
    colors.push('#e4b152bf');
    //red
    colors.push('#fab3ae');
    //grey
    colors.push('#9e9e9ebf');

    const supposedIncreasedRent = Math.round(currentRent * 1.05);
    const marketIsGreater = goingRent >= supposedIncreasedRent

    let category;
    if (whip_status === 'verified' &&  marketIsGreater === true) {

        category = {
            formula: '5% increase',
            color: colors[0]
        };
    }
    else if (whip_status === 'resident_opt_out') {

        category = {
            formula: 'Market',
            color: colors[2]
        };

    }
    else if (bestRate === Math.round(currentRent * 1.15)) {
        category = {
            formula: '15% increase',
            color: colors[0]
        };
    }
    else if (bestRate === Math.round(currentRent * 1.12)) {
        category = {
            formula: '12% increase',
            color: colors[0]
        };
    }
    else if (bestRate === Math.round(currentRent * 1.10)) {
        category = {
            formula: '10% increase',
            color: colors[0]
        };
    }
    else if (bestRate === Math.round(currentRent * 1.07)) {
        category = {
            formula: '7% increase',
            color: colors[0]
        };
    }
    // else if (bestRate === Math.round(goingRent * 0.88)) {
    //     category = {
    //         formula: '88% of Market',
    //         color: colors[1]
    //     };
    // }
    else if (bestRate === Math.round(currentRent * 1.05)) {
        category = {
            formula: '5% increase',
            color: colors[1]
        };
    }
    else {
        category = {
            formula: 'Market',
            color: colors[2]
        };
    }

    return category;
};


function countLegend(renewals){

    const renewalsWithFormula = renewals.map(renewal => ({
        ...renewal,
        formula: categorizeIncrease(Math.min(...renewal.pricing), renewal.current_rent, renewal.going_rent, renewal.whip_status).formula,
        color: categorizeIncrease(Math.min(...renewal.pricing), renewal.current_rent, renewal.going_rent, renewal.whip_status).color
    }));

    const groupBy = function(xs, key) {
        return xs.reduce((rv, x) => {
            (rv[x[key]] = rv[x[key]] || []).push(x);

            return rv;
        }, {});
    };

    const risultato = Object.entries(groupBy(renewalsWithFormula, 'formula'));

    return risultato.map(p => ({
        color: p[1][0].color,
        formula: p[0],
        value: p[1].length
    }));
}

const LegendColor = props => {

    const { color } = props;

    return (
        <div style={{
            width: '12px',
            height: '12px',
            margin: '1.5px',
            marginTop: 4,
            backgroundColor: color
        }}></div>
    );
};

const Legend = props => {

    const { renewals } = props;

    const formula = countLegend(renewals);

    return (
        <Card style={{ width: '300px' }}>
            <CardContent>
                <Grid container>
                    <Grid container item justifyContent='space-between'>
                        <Typography>
                            <strong>Formula</strong>
                        </Typography>
                        <Typography>
                            <strong>Count</strong>
                        </Typography>
                    </Grid>
                    { formula.map(f => <Grid container item justifyContent='space-between'>
                        <Typography style={{ display: 'flex' }}>
                            <LegendColor color={f.color}/>
                            &nbsp;
                            <div>
                                {f.formula}
                            </div>
                        </Typography>
                        <Typography>
                            <strong>{f.value}</strong>
                        </Typography>
                    </Grid>
                    )}
                </Grid>
            </CardContent>
        </Card>
    );
};

const List = props => {

    const {
        getRenewals,
        match,
        renewals,
        updateRenewal
    } = props;

    const sortedRenewalsByUnitNumber = orderBy(renewals, ['unit_number']);

    const { property_id } = match.params;
    const { ref, Trigger } = usePrint();
    const [activeNote, setActiveNote] = useState(-1);
    const { data: property } = useProperty(property_id);

    const [fromDate, setFromDate] = React.useState();
    const [toDate, setToDate] = React.useState();


    const handleDate = event => {

        const valueFrom = dayjs(event.target.value).date(1).format('MM-DD-YYYY 00:00:00');

        const valueTo = dayjs(valueFrom).endOf('month').format('MM-DD-YYYY 23:59:59');

        setFromDate(
            valueFrom
        );

        setToDate(
            valueTo
        );
    };

    const now = dayjs();

    const dates = useMemo(() => (
        [
            dayjs(now).subtract(4, 'months'),
            dayjs(now).subtract(3, 'months'),
            dayjs(now).subtract(2, 'months'),
            dayjs(now).subtract(1, 'months'),
            dayjs(now),
            dayjs(now).add(1, 'months'),
            dayjs(now).add(2, 'months'),
            dayjs(now).add(3, 'months'),
            dayjs(now).add(4, 'months')
        ]
            .map(dateAtMidnight)
            .map(d => d.toString())
    ), [now]);

    useEffect(() => {
        getRenewals({
            property_id,
            fromDate,
            toDate
        });

    }, [property_id, getRenewals, fromDate, toDate]);

    const hasData = useMemo(() => Object.keys(renewals).length > 0, [renewals]);


    const handleSaveNotes = renewal => {
        const { value } = document.querySelector('#note-input');

        updateRenewal({
            ...renewal,
            notes: value
        });
        setActiveNote(-1);
    };

    const alredy_renewed = {
        backgroundColor: '#fcfcfc',
	    opacity: '0.4'
    };

    const categorizeIncreaseCalculation = renewal => categorizeIncrease(Math.min(...renewal.pricing), renewal.current_rent, renewal.going_rent, renewal.whip_status);

    return (
        <div ref={ref} className='print_renewals' >
            <div style={styles.headerContainer} >
                <div>
                    <Trigger />
                </div>
                <br/>
                <div style={styles.header}>
                    <div style={styles.logoWrapper}>
                        <div style={styles.logo}>
                            <img src={logo} alt='logo' width='100' height='87.5' />
                            {property?.name}
                        </div>
                    </div>
                </div>
                <br/><br/><br/><br/><br/><br/><br/><br/>

                <div style={{
                    // ...styles.headerContainer,
                    display: 'flex',
                    flexDirection: 'row',
                    width: '100%'
                }}>
                    <div>
                        <Box sx={{ minWidth: 120 }}>
                            <FormControl style={{ width: '300px' }}>
                                <InputLabel id='demo-simple-select-label'>Period</InputLabel>
                                <Select
                                    labelId='demo-simple-select-label'
                                    id='demo-simple-select'
                                    label='Date'
                                    onChange={e => handleDate(e)}
                                >
                                    {
                                        (dates || []).map((date, i) => (
                                            <MenuItem value={date}>{formattedDate(date)}</MenuItem>
                                        ))
                                    }

                                </Select>
                            </FormControl>
                        </Box>
                    </div>
                    <div style={{
                        marginLeft: '43%'
                    }}>
                        {hasData && (
                            <Legend renewals={sortedRenewalsByUnitNumber}/>
                        )}
                    </div>
                </div>
            </div>
            {/* <br/><br/>
            {hasData && (
                <Grid container item justifyContent='space-between'>
                    <div>
                        <div className='legend disabled-legend'/>
                        <Typography variant='body2' display='inline'> Already Renewed </Typography>
                    </div>
                </Grid>
            )} */}

            {hasData && (
                <div>
                    <div>
                        <PrintDate isForPDF={false} />
                    </div>

                    <Table celled compact>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell collapsing singleLine content='Unit' />
                                <Table.HeaderCell collapsing singleLine content='Lease To' />
                                <Table.HeaderCell collapsing singleLine content='Type' />
                                <Table.HeaderCell collapsing singleLine content='Resident' />
                                <Table.HeaderCell collapsing singleLine content='Status' />
                                <Table.HeaderCell className='comments' content='Comments'/>
                                <Table.HeaderCell collapsing singleLine content='Whip' />
                                <Table.HeaderCell collapsing singleLine content='Formula' />
                                <Table.HeaderCell collapsing singleLine content='Going' />
                                <Table.HeaderCell collapsing singleLine content='Current' />
                                {[7, 8, 9, 10, 11, 12, 13, 14].map((i, ind) => <Table.HeaderCell collapsing key={ind} content={i} textAlign='center' />)}
                                <Table.HeaderCell collapsing key={8} content={18} textAlign='center' />
                                <Table.HeaderCell collapsing content='Inc.' />
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {sortedRenewalsByUnitNumber.map((renewal, i) => (

                                <Table.Row key={`row-${i}` } style={ renewal.renewed === 1 ? alredy_renewed : null }>
                                    <Table.Cell singleLine content={renewal.unit_number} />
                                    <Table.Cell singleLine content={dayjs(renewal.lease_end_date.substring(0, renewal.lease_end_date.indexOf('T'))).format('MM/DD/YY')} />
                                    <Table.Cell singleLine content={renewal.unit_type} />
                                    <Table.Cell singleLine content={renewal.resident} />
                                    <Table.Cell singleLine content={capitalize(renewal.lease_status)} />
                                    {
                                        activeNote === renewal.id
                                            ? <Table.Cell >
                                                <Input
                                                    fluid
                                                    id='note-input'
                                                    defaultValue={renewal.notes}
                                                    icon={<Icon
                                                        name='save'
                                                        inverted
                                                        circular
                                                        link
                                                        onClick={() => handleSaveNotes(renewal)}
                                                    />}
                                                />
                                            </Table.Cell>
                                            : <Table.Cell onClick={() => setActiveNote(renewal.id)}>
                                                {renewal.notes}
                                            </Table.Cell>
                                    }
                                    <Table.Cell singleLine content={renewal.whip_status} />
                                    <Table.Cell
                                        style={{ color: categorizeIncreaseCalculation(renewal).color }}
                                        content={categorizeIncreaseCalculation(renewal).formula} />
                                    <Table.Cell content={renewal.going_rent} />
                                    <Table.Cell content={renewal.current_rent} />
                                    {priceMapper(renewal)}
                                    <Table.Cell content={(Math.min(...renewal.pricing) - renewal.current_rent)} />
                                </Table.Row>
                            ))}
                        </Table.Body>
                    </Table>
                </div>
            )}

            { !hasData && (
                <h2>No results</h2>
            )}
        </div>
    );
};


const priceMapper = (renewal) => {

    if (renewal.unit_number === '790-318A'){
        // console.log('got ya')
        // console.log(renewal)
    }
    const {
        pricing,
        whip_status,
        going_rent,
        current_rent
    } = renewal

    const clone = [...pricing, pricing[5]];
    const lowestPrice = Math.min(...pricing);

    const greenBackground = {
        backgroundColor: '#66e952',
        color: 'white'
    };

    const whiteBackground = {
        backgroundColor: 'white',
        color: 'white'
    };

    if (whip_status === 'verified') {
        return clone.map((price, i) => {

            // console.log(i)

            const isLowest = Number(price) === lowestPrice && lowestPrice !== 0;

            const supposedIncreasedRent = Math.round(current_rent * 1.05);
            const marketIsGreater = going_rent >= supposedIncreasedRent
           
            return (
                <Table.Cell
                    textAlign='center'
                    key={`parsedPrice-${i}`}
                    content={(i === 5 && marketIsGreater ? supposedIncreasedRent : going_rent)}
                    style={ i === 5 ? greenBackground: whiteBackground  }
                />
            );
        });
    }

    if (whip_status === 'resident_opt_out') {
        const diff = going_rent - lowestPrice;

        return clone.map((price, i) => {

            const isLowest = Number(price) === lowestPrice && lowestPrice !== 0;

            return (
                <Table.Cell
                    textAlign='center'
                    key={`parsedPrice-${i}`}
                    content={price + diff}
                    style={{
                        ...(isLowest ? greenBackground : {})
                    }}
                />
            );
        });
    }

    return clone.map((price, i) => {
        // console.log(i)

        const isLowest = Number(price) === lowestPrice && lowestPrice !== 0;
       
        return (
            <Table.Cell
                textAlign='center'
                key={`parsedPrice-${i}`}
                content={price}
                style={{
                    ...(isLowest ? greenBackground : {})
                }}
            />
        );
    });

};

const mapStateToProps = (state, ownProps) => ({
    renewals: Object.values(state.renewals.data),
    property: state.properties.data[ownProps.match.params.property_id]
});

const actions = {
    getRenewals: renewalActions.getRenewals,
    updateRenewal: renewalActions.updateRenewal
};

export default connect(mapStateToProps, actions)(List);
